const Link = require('components/Link/Link');
module.exports = Link;
